<template>
  <div class="soundIntroduce" style="width:100%;height:100%">
    <!-- AI语音解决方案 -->
    <div class="aiSkill">
      <!--      <div class="aiSkillTitle">技术指标</div>-->

      <!--      <div class="aiSkillFlex">-->
      <!--        <div class="aiSkillLeft">技术指标</div>-->
      <!--        <div class="aiSkillCenter"></div>-->
      <!--        <div class="aiSkillRight">-->
      <!--          <div>• 支持模拟、数字音源，分布式多路并行处理</div>-->
      <!--          <div>• 支持实时音源和录音音源两种处理方式；</div>-->
      <!--          <div>• 支持音频自动切分、降噪；</div>-->
      <!--          <div>• 识别延迟<0.3秒；</div>-->
      <!--          <div>• 支持中英文混合识别；</div>-->
      <!--          <div>• 可提供音频训练和指令模板开发工具包；</div>-->
      <!--          <div>• 输出内容：STT文本，结构化指令</div>-->
      <!--          <div>• 输出方式：队列、API、数据库</div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!-- <div class="aiSoundbackground"></div> -->
      <div class="aiSkill-content">
        <div style="display: flex;justify-content: center;">
          <div class="content-top">
            管制培训
          </div>
        </div>
        <div class="content-info">
          <div>
            <div class="info-bg">
              <div class="info-img">
              </div>
              <div class="info-title">SimATC模拟管制培训平台</div>
            </div>
            <div class="info-content">
              定制化还原机场业务场景，提供AI机长互动，支持复杂的高、低流量混合培训和特殊场景培训，提供实时管制能力评价与个人管制培训履历记录，可随时随地磨练管制技能。
            </div>
          </div>
          <div style="margin-left: 140px">
            <div class="info-bg2">
              <div class="info-img2">
              </div>
              <div class="info-title">课程管理系统</div>
            </div>
            <div class="info-content">
              支持自定义基础试题课程、语音训练课程、模拟培训课程的管理，拥有高自由度的课程编辑和航班路线规划功能，可随时调阅学员管制履历，提供针对性强的管制人才培养方案。
            </div>
          </div>
          <div style="margin-left: 140px">
            <div class="info-bg3">
              <div class="info-img3">
              </div>
              <div class="info-title">数字化履历系统</div>
            </div>
            <div class="info-content">
              管制员培训考核神器，拥有完善的空管专业技能试题、定制化的机场运行规则题库，更有语音AI助教辅导管制用语训练，帮助新老管制员巩固基础业务知识，规范化管制用语。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.aiSkill-content {

  .content-info {
    display: flex;

    .info-content {
      width: 315px;
      font-size: 16px;
      margin-top: 30px;
    }
    .info-title {
      color: #ffffff;
      margin-top: 40px;
      font-size: 20px;
    }
    .info-bg {
      background: url("../assets/simATC.png") no-repeat;
      height: 360px;
      width: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .info-img {
        width: 92px;
        height: 105px;
        background: url("../assets/atc1.png") no-repeat;
        background-position: left 54% top 30%;
      }
    }

    .info-bg2 {
      background: url("../assets/kcgl.png") no-repeat;
      height: 360px;
      width: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .info-img2 {
        width: 92px;
        height: 105px;
        background: url("../assets/kcgl1.png") no-repeat;
        background-position: left 54% top 30%;
      }
    }
    .info-bg3 {
      background: url("../assets/szh.png") no-repeat;
      height: 360px;
      width: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .info-img3 {
        width: 92px;
        height: 105px;
        background: url("../assets/szh2.png") no-repeat;
      }
    }
  }

  .content-top {
    width: 165px;
    height: 51px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid rgb(243, 103, 65);
    font-size: 24px;
    color: rgb(243, 103, 65);
    margin-bottom: 127px;
  }
}

.aiSkillTitle {
  width: 100%;
  font-size: 40px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #ff714e;
  text-align: center;
  margin-bottom: 84px;
}

.aiSkillRight {
  height: 570px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: #646464;
  font-size: 20px;
  margin-left: 48px;
}

.aiSkillCenter {
  width: 99px;
  height: 589px;
  background: url("../../../common/commonImages/ai_10.png") no-repeat;
  background-size: 100%;
}

.aiSkillLeft {
  height: 128px;
  width: 130px;
  padding-top: 82px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 20px;
  color: #ee6240;
  clear: both;
  background: url("../../../common/commonImages/ai_9.png") no-repeat;
  background-size: 78px 81px;
  background-position-y: top;
  background-position-x: center;
}

.aiSkill {
  display: flex;

  align-items: flex-start;

  justify-content: flex-start;

  flex-direction: column;
  //background: url("../../../common/commonImages/ai_33.png") no-repeat;
  background-size: 662px;
  background-position-y: bottom;
  background-position-x: right;
}

.aiSkillFlex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.soundIntroduce {
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<script>
export default {
  name: "HomeSlide1",
  data() {
    return {};
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {}
};
</script>
